"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_redux_api_1 = require("lp-redux-api");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const reducer_1 = require("../../reducer");
const AccountLookupForm_1 = __importDefault(require("../forms/AccountLookupForm"));
const Routes_1 = require("../Routes");
function AccountLookup({ currentLocation, loading, searchForAccounts, }) {
    // Context
    const ctx = (0, react_1.useContext)(Routes_1.LookupContext);
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const handleSubmit = (data) => {
        return searchForAccounts({
            ...data,
            locationId: currentLocation.locationId,
        });
    };
    const handleSubmitSuccess = () => {
        if (ctx.isTransact) {
            history.push('/merchant/sales/lookup/result');
        }
        else {
            history.push(config_1.ACCOUNT_LOOK_UP_RESULT_URL);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "account-lookup", children: [(0, jsx_runtime_1.jsxs)(components_1.H1, { children: [ctx.isTransact ? 'Transact' : 'Account', " Lookup"] }), (0, jsx_runtime_1.jsxs)(components_1.H2, { variant: "headline-small", children: ["Select how you would like to ", ctx.isTransact ? 'transact' : 'search', ' ', "for an account"] }), (0, jsx_runtime_1.jsx)(AccountLookupForm_1.default, { onSubmit: handleSubmit, onSubmitSuccess: handleSubmitSuccess, onSubmitFail: utils_1.flashSubmitFailure }), loading && (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true })] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
        loading: lp_redux_api_1.selectors.isLoading(state, 'ACCOUNT_DATA'),
    };
}
const mapDispatchToProps = {};
const mapApiAuthToProps = {
    searchForAccounts: apiActions.searchForAccounts,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(AccountLookup);
